export class ControllerBase {

    constructor() {

    }

}


// WEBPACK FOOTER //
// ./src/app/components/framework/controller-base.ts